export const BUILD_REVISION = __BUILD_REVISION__

export const RELOAD_REQUEST_KEY = 'fos:pwa-reload-request'
export const UPDATE_DEFERRED_KEY = 'fos:pwa-update-deferred'
export const UPDATE_APPLIED_KEY = 'fos:pwa-update-applied'

const EDITABLE_SELECTOR = [
  'input:not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="hidden"])',
  'textarea',
  'select',
  '[contenteditable="true"]',
].join(',')

const ENTRY_SELECTOR = '[data-update-entry="true"]'
const ENTRY_FIELDS = `${ENTRY_SELECTOR} :is(${EDITABLE_SELECTOR})`
const initialValues = new WeakMap()

function fieldValue(field) {
  if (field.type === 'checkbox' || field.type === 'radio') return field.checked
  if (field.tagName === 'SELECT') {
    return JSON.stringify(Array.from(field.options).filter(option => option.selected).map(option => option.value))
  }
  return field.isContentEditable ? field.textContent : field.value
}

// Capture after a surface mounts, before user input. Never replace a baseline
// on rerender: controlled React fields also update their DOM defaultValue.
export function captureUpdateEntryValues(doc = document) {
  for (const field of doc.querySelectorAll(ENTRY_FIELDS)) {
    if (!initialValues.has(field)) initialValues.set(field, fieldValue(field))
  }
}

function fieldChanged(field) {
  if (field.disabled || field.readOnly) return false
  if (field.tagName === 'SELECT') {
    const defaults = Array.from(field.options).filter(option => option.defaultSelected)
    if (defaults.length) {
      return fieldValue(field) !== JSON.stringify(defaults.map(option => option.value))
    }
    // A programmatic initial selection need not be the first option.
    return initialValues.has(field) && fieldValue(field) !== initialValues.get(field)
  }
  if (initialValues.has(field)) return fieldValue(field) !== initialValues.get(field)
  if (field.type === 'checkbox' || field.type === 'radio') return field.checked !== field.defaultChecked
  return field.value !== field.defaultValue
}

export function isUpdateReloadBlocked(doc = document) {
  if (doc.querySelector('[data-update-blocking="true"]')) return true

  const active = doc.activeElement
  if (active?.closest?.(ENTRY_SELECTOR) && active.matches?.(EDITABLE_SELECTOR) && !active.disabled && !active.readOnly) return true

  return Array.from(doc.querySelectorAll(ENTRY_FIELDS)).some(fieldChanged)
}

export async function fetchDeployedRevision() {
  const response = await fetch(`/version.json?checked=${Date.now()}`, {
    cache: 'no-store',
    headers: { Accept: 'application/json' },
  })
  if (!response.ok) throw new Error(`Version check failed (${response.status})`)
  const body = await response.json()
  return typeof body.revision === 'string' ? body.revision : ''
}

export function shortRevision(revision) {
  if (!revision) return ''
  const uuid = revision.split('-').slice(-5).join('-')
  return uuid.slice(0, 8)
}
